// src/services/tradingService.js
import api from './api';

const createOrder = (payload) => {
  return api.post('/trading/orders', payload);
};

const listMyOrders = (params = {}) => {
  return api.get('/trading/orders', { params });
};

const cancelOrder = (orderId) => {
  return api.put(`/trading/orders/${orderId}/cancel`);
};

const getOrderBook = (tokenId) => {
  return api.get(`/trading/orderbook/${tokenId}`);
};

const getRecentTrades = (tokenId) => {
  return api.get(`/trading/trades/${tokenId}`);
};

const getMyTradingHoldings = () => {
  return api.get('/trading/my-holdings');
};

const getTokenPrice = (tokenId) => {
  return api.get(`/trading/price/${tokenId}`);
};

const tradingService = {
  createOrder,
  listMyOrders,
  cancelOrder,
  getOrderBook,
  getRecentTrades,
  getMyTradingHoldings,
  getTokenPrice,
};

export default tradingService;
